<template>
  <div class="clinic-wechat-qr-wrap" @click="handleCopy($event)" v-if="wechatBindState">
    <div class="qrcode-title" v-if="showHead" :style="'color:' + colorTitle">诊所微信二维码</div>
    <div class="qrcode-container" :id="id"></div>
    <div class="qrcode-description" v-if="showFoot" :style="'color:' + colorFoot">单击复制链接</div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {mapGetters} from 'vuex'
import handleClipboard from '@/utils/clipboard'

export default {
  name: 'clinicWechatQr',
  components: {},
  props: {
    clinicCode: {
      type: String
    },
    colorDark: {
      type: String,
      default: '#000'
    },
    colorLight: {
      type: String,
      default: '#fff'
    },
    colorTitle: {
      type: String,
      default: '#2c3e50'
    },
    colorFoot: {
      type: String,
      default: '#c4c2c2'
    },
    // 二维码尺寸
    qrSize: {
      type: Number,
      default: 140
    },
    id: {
      type: String,
      default: 'clinicWechatQRContainer'
    },
    // 鼠标放在二维码上，是否显示url链接
    hideTitle: {
      type: Boolean,
      default: false
    },
    showHead: {
      type: Boolean,
      default: true
    },
    showFoot: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      qrUrl: '',
      // 二维码对象
      qrCodeObj: null
    }
  },
  computed: {
    ...mapGetters(['tenantInfo']),
    // 租户是否绑定了公众号
    wechatBindState() {
      return this.tenantInfo.wechatBindState === 1
    }
  },
  mounted() {
    if (this.wechatBindState) {
      this.loadQR()
    }
  },
  methods: {
    loadQR() {
      const tenantCode = this.tenantInfo.tenantCode
      const nameCode = this.tenantInfo.nameCode
      const clinicCode = this.clinicCode
      // 'https://tcm.ai-tongue.com/tad-business-backend/wechatOpen/component/mp/auth/0/tenant/getCode?returnUrl=diagnosis-h5/firstIn/yzkj/C00000002'
      this.qrUrl = `${window.location.protocol}//${window.location.host}/tad-business-backend/wechatOpen/component/mp/auth/${tenantCode}/tenant/getCode?returnUrl=diagnosis-h5/firstIn/${nameCode}/${clinicCode}`

      this.qrcode = new QRCode(this.id, {
        width: this.qrSize,
        height: this.qrSize,
        text: this.qrUrl,
        title: '11223',
        colorDark: this.colorDark,
        colorLight: this.colorLight
      })
      if (this.hideTitle) {
        // 鼠标放在二维码上 默认会显示url链接
        this.qrcode._el.title = ''
      }
    },
    handleCopy(event) {
      handleClipboard(this.qrUrl, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.clinic-wechat-qr-wrap {
  position: absolute;
  left: 14px;
  bottom: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  cursor: pointer;

  .qrcode-title {
    font-size: 16px;
    padding: 4px 0;
  }

  .qrcode-description {
    font-size: 12px;
    padding: 8px 0;
    color: #c4c2c2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/doctor/diagnosis/start/clinic-wechat-qr.vue